import React, { FC } from 'react';

import { getClassNames } from './Paragraph.styles';

/**
 * Paragraph is a simple styled replacement for a `p` tag.
 */
const Paragraph: FC = ({ children }) => (
  // eslint-disable-next-line react/forbid-elements
  <p className={getClassNames().paragraph}>{children}</p>
);

export default Paragraph;
